(function() {
    /** @ngInject */
    function bookingDetailsCtrl($scope,  $timeout){
        $scope.link_copied = false;
        $scope.booking.cancellationEmail = false;
        $scope.successMSG = true; //_booking !== false ? false : true;
        alertify.set('notifier','position', 'bottom-left');

        $scope.showInvite = function(){
            $scope.template = 'invite';
        };
        $scope.reload = function(){
            window.location.reload();
        };
        $scope.setConfirm = function(){
            $scope.setTemplate('confirm');
        };
        $scope.closePanel = function(){
            if(window.self !== window.top && typeof(window.parent) !== 'undefined') {
                window.parent.postMessage('closed', "*");
                window.parent.postMessage('closeWaiteraidFrame', "*");
            }else {
                window.location = '/reservation/?hash=' + hash;
                return;
            }
        };
        $scope.sendGroupInvite = function(){
            $scope.booking.sendGroupInvitation($scope.invite_form).then(function(){
                $scope.invite_form.email = '';
            });
        }

        $scope.allow_allergies = settings.allow_allergies;
        var allergies_panel = {open : false};
        $scope.changingAllergies = function(){
            $scope.setTemplate('allergy-confirmation');
                //return allergies_panel.open;
        };
        $scope.openAllergiesPanel = function(){
            allergies_panel.open = true;
        };
        $scope.needAllergyConfirmation = function(){
          return settings.allow_allergies == true && $scope.booking.meal.type != 8 && $scope.booking.meal.type != 10;
        };
        $scope.requireAllergyConfirmation = function(){
            return $scope.allow_allergies === true && $scope.booking.allergies_confirmed === 0;
        };
        $scope.confirmAllergy = function(){
            $scope.setTemplate('allergy-confirmation');
        };
		$scope.pm_flags = pm_flags;
		$scope.go_to_accept = function(){
			window.location = 'http://waiteraid.com/flag_confirm.php?id=' + $scope.booking.short_code;
		};
        $scope.cancel = function(){
            if($scope.booking.too_late_to_cancel == true) return;
            if($scope.booking.status == 1) {
                if(delete_confirm_txt && confirm(delete_confirm_txt)) {
                    if(settings.confirm_cancellation == true) {
                        $scope.booking.sendCancellationEmail().success(function (response) {
                            if (response.success != true) {
                                alert(response.errors);
                                return false;
                            } else {
                                $scope.booking.cancellationEmail = true;
                                updateWidgetStep('Reservation-Cancelled', {bookingId: $scope.booking.book_id});
                                //window.location.reload();
                            }
                        });
                    }else {
                        $scope.booking.cancel().success(function (response) {
                            if (response.success != true) {
                                alert(response.errors);
                                return false;
                            } else {
                                //send cancellation event
                                updateWidgetStep('Reservation-Cancelled', {bookingId: $scope.booking.book_id});
                                window.location.reload();
                            }
                        });
                    }


                }
            }
        };
        $scope.bookingProductsCost = function(){
            var t=0.0;
            for(x in $scope.booking.products){
                t+= parseFloat($scope.booking.products[x].meal_price) * parseFloat($scope.booking.products[x].amount);
            }
            return t;
        };
        $scope.copyInviteLink = function(){
            var url = $scope.booking.invitationCode;
            var aux = document.createElement("input");
            aux.setAttribute("value", url);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
            $scope.link_copied = true;
            $timeout(function(){
                $scope.link_copied = false;
            },3000);
        };
        $scope.bookingProductCost = function(p){
            return parseFloat(p.amount) * parseFloat(p.meal_price);
        }
        $scope.isGiftCard = function(){
            if($scope.booking.meal && $scope.booking.meal.type == 8) {
                return true;
            }
            return false;
        };
        window.setTimeout(sendHeightEvent, 800);


    }
    angular.module("Waiteraid").controller('bookingDetailsCtrl',bookingDetailsCtrl);
})();
